
var _StrTeg="";
var _StrCoutCredit="";


var gNbLigne=0;
var gTblNbMois	=new Array(301);
var gTblCrd	=new Array(301);
var gTblAmort	=new Array(301);
var gTblInteret =new Array(301);
var gTblEcheance=new Array(301);
var gTblAdi1	=new Array(301);
var gTblAdi2	=new Array(301);

var _PretMontant=0;
var _PretTaux=0;
var _PretNbMois=0;
var _PretDiffa=0;
var _PretDifft=0;
var _PretAstm=4;
var _AdiTaux1=0;
var _AdiTaux2=0;
var _AdiMode1=1;
var _AdiMode2=1;
var _FraisDossier=0;
var _FraisGarant=0;



function GetNbMoisAstm(astm)
{
var tmp;

tmp=(astm==4) ? 1
   :(astm==3) ? 3
   :(astm==2) ? 6
   :(astm==1) ? 12 : 0;

return(tmp);
}


function TesteData()
{
var nb;
var tmp;

if(_PretMontant<=0 ||
   _PretNbMois<=0 ||
   _PretNbMois>300 ||
   _PretDiffa<0 ||
   _PretDifft<0 ||
   _PretTaux<=0 ||
   _PretTaux>=25 ||
   _PretAstm<=0 ||
   _FraisDossier<0 ||
   _FraisGarant<0)
     { return(-1);
     }

nb=GetNbMoisAstm(_PretAstm);
if(!nb)
     { return(-2);
     }
tmp=_PretNbMois-(_PretDiffa+_PretDifft);
if(tmp<=0)
     { return(-3);
     }
if(tmp%nb)
     { return(-4);
     }
if(_PretDiffa%nb)
     { return(-5);
     }

return(0);
}


function PretCoutCredit()
{
var i;
var TotalEch=0;
var TotalAdi1=0;
var TotalAdi2=0;
var cout;


_StrCoutCredit="";
if(gNbLigne<=0)
    { return(-1);
    }

for(i=0; i<gNbLigne; i++)
    {
      TotalEch +=gTblEcheance[i];
      TotalAdi1+=gTblAdi1[i];
      TotalAdi2+=gTblAdi2[i];
    }
cout=(TotalEch-_PretMontant)
    +TotalAdi1
    +_FraisDossier;

cout+=_FraisGarant;


_StrCoutCredit=FormateVal(cout,2)+" €";

return(0);
}


function PretCalculTotaux()
{
var amort   =0;
var interet =0;
var echeance=0;
var adi1    =0;
var adi2    =0;


if(gNbLigne<=0)
    { return(-1);
    }
for(i=0; i<gNbLigne; i++)
    {
      amort   +=gTblAmort   [i];
      interet +=gTblInteret [i];
      echeance+=gTblEcheance[i];
      adi1    +=gTblAdi1    [i];
      adi2    +=gTblAdi2    [i];
    }

gTblAmort   [gNbLigne]=amort   ;
gTblInteret [gNbLigne]=interet ;
gTblEcheance[gNbLigne]=echeance;
gTblAdi1    [gNbLigne]=adi1    ;
gTblAdi2    [gNbLigne]=adi2    ;

return(0);
}


function FillTblAmort()
{
var NbLig;
var TauxPer;
var TauxReel;
var NbMoisPer;
var NbPerAn;
var NbPerPer;
var NbPer;
var NumPer;
var NumMois;
var interet;
var amort;
var echeance;
var crd;
var BaseAdi1;
var BaseAdi2;
var TauxAdi1;
var TauxAdi2;
var TauxAdd;
var tempd;


NbLig=0;
crd=_PretMontant;
NbMoisPer=GetNbMoisAstm(_PretAstm);
NbPerAn=12/NbMoisPer;
TauxPer=(_PretTaux/100.0)/NbPerAn;
TauxAdi1=0;
TauxAdi2=0;
BaseAdi1=crd;
BaseAdi2=crd;
TauxAdd=0;

if(_AdiTaux1 && _AdiMode1)
    { TauxAdi1=(_AdiTaux1/100.0);
      if(_AdiMode1!=3)
	   { TauxAdi1/=NbPerAn;
	   }
      if(_AdiMode1==2)
	   { TauxAdd+=TauxAdi1;
	   }
    }
if(_AdiTaux2 && _AdiMode2)
    { TauxAdi2=(_AdiTaux2/100.0);
      if(_AdiMode2!=3)
	   { TauxAdi2/=NbPerAn;
	   }
      if(_AdiMode2==2)
	   { TauxAdd+=TauxAdi2;
	   }
    }

NbLig=0;

var NumDifft=_PretDifft;
for(NumMois=_PretDifft+_PretDiffa; NumMois>0; NumMois-=NbMoisPer)
    {

      TauxReel=TauxPer;
      if(NumMois<NbMoisPer)
	  { TauxReel*=NumMois/NbMoisPer;
	  }
      interet=crd*TauxReel;
      echeance=(NumDifft>0) ? 0 : interet;

      if(NumMois<NbMoisPer)
	  { gTblNbMois[NbLig]=(_PretDifft+_PretDiffa);
	  }
      else{ gTblNbMois[NbLig]=(_PretDifft+_PretDiffa)-NumMois+NbMoisPer;
	  }
      gTblAmort[NbLig]	 =0;
      gTblInteret[NbLig] =interet;
      gTblEcheance[NbLig]=echeance;

      if(TauxAdi1)
	  {
	    if(_AdiMode1==2)
		{ BaseAdi1=crd;
		}
	    else
	    if(_AdiMode1==3)
		{ BaseAdi1=echeance;
		}
	    tempd=BaseAdi1*TauxAdi1;
	    if(NumMois<NbMoisPer)
		{ tempd*=NumMois/NbMoisPer;
		}
	    gTblAdi1[NbLig]=tempd;
	  }
      else{ gTblAdi1[NbLig]=0;
	  }

      if(TauxAdi2)
	  {
	    if(_AdiMode2==2)
		{ BaseAdi2=crd;
		}
	    else
	    if(_AdiMode2==3)
		{ BaseAdi2=echeance;
		}
	    tempd=BaseAdi2*TauxAdi2;
	    if(NumMois<NbMoisPer)
		{ tempd*=NumMois/NbMoisPer;
		}
	    gTblAdi2[NbLig]=tempd;
	  }
      else{ gTblAdi2[NbLig]=0;
	  }

      if(NumDifft>0)
	  { crd+=interet;
	    NumDifft-=NbMoisPer;
	    if(NumDifft<0) NumDifft=0;
	  }
      gTblCrd[NbLig] =crd;
      NbLig++;
    }

NbPer=(_PretNbMois-(_PretDifft+_PretDiffa))/NbMoisPer;

tempd=TauxPer+TauxAdd;
echeance=crd*(tempd/(1-Math.pow(1+tempd, -NbPer)));

for(NumPer=0; NumPer<NbPer; NumPer++)
    {
      interet=crd*TauxPer;
      amort=echeance-(interet+(crd*TauxAdd));

      gTblNbMois[NbLig]  =(_PretDifft+_PretDiffa)+(NumPer+1)*NbMoisPer;
      gTblAmort[NbLig]	 =amort;
      gTblInteret[NbLig] =interet;
      gTblEcheance[NbLig]=amort+interet;

      if(TauxAdi1)
	  {
	    if(_AdiMode1==2)
		{ BaseAdi1=crd;
		}
	    else
	    if(_AdiMode1==3)
		{ BaseAdi1=amort+interet;
		}
	    gTblAdi1[NbLig]=BaseAdi1*TauxAdi1;
	  }
      else{ gTblAdi1[NbLig]=0;
	  }

      if(TauxAdi2)
	  {
	    if(_AdiMode2==2)
		{ BaseAdi2=crd;
		}
	    else
	    if(_AdiMode2==3)
		{ BaseAdi2=amort+interet;
		}
	    gTblAdi2[NbLig]=BaseAdi2*TauxAdi2;
	  }
      else{ gTblAdi2[NbLig]=0;
	  }

      crd-=amort;
      gTblCrd[NbLig]=crd;
      NbLig++;
    }

gNbLigne=NbLig;

return(NbLig);
}


function PretCalculTeg()
{
var IsValid=0;
var teg;
var tegMin;
var tegMax;
var van;

_StrTeg="";
if(gNbLigne<=0)
    { return(-1);
    }

for(tegMin=0, tegMax=40;;)
    {
      teg=tegMin+(tegMax-tegMin)/2;
      if(tegMax-tegMin<0.001)
	  { IsValid=1;
	    break;
	  }

      van=PretCalculVan(gNbLigne, teg);

      if(van==0)
	  { IsValid=1;
	    break;
	  }
      if(van<0)
	  { tegMax=teg;
	  }
      else{ tegMin=teg;
	  }
    }

if(IsValid)
    { _StrTeg=FormateVal(teg,2)+"%";
    }

return(0);
}


function PretCalculVan(NbLigne, TauxActu)
{
var   i;
var   van;
var   tempd;
var   tempd1;


van=-_PretMontant;
van+=_FraisDossier;
van+=_FraisGarant;

tempd1=Math.pow(1+TauxActu/100, -1.0/12);

for(i=0; i<NbLigne; i++)
    {
      tempd=gTblEcheance[i]
	   +gTblAdi1[i];

      van+=tempd * Math.pow(tempd1, gTblNbMois[i]);
    }

return(van);
}


var gIsChange1=0;
var gIsChange2=0;

function ffff_OC_TAmort(r)
{ gIsChange1=1;
}

function checkInputAmortissment(f,IsAlert)
{
var err=0;
var errF = null;

if( GetNum(f.PretMontant.value , 70)<=0) { err=101; errF = f.PretMontant } else
if(TestNum(f.PretTaux.value    , 22)<=0) { err=102; errF = f.PretTaux } else
if( GetNum(f.PretNbMois.value  , 30)<=0) { err=103; errF = f.PretNbMois } else
if(TestNum(f.PretDiffa.value   , 30)< 0) { err=104; errF = f.PretDiffa } else
if(TestNum(f.PretDifft.value   , 30)< 0) { err=105; errF = f.PretDifft } else
if(TestNum(f.AdiTaux1.value    , 14)< 0) { err=201; errF = f.AdiTaux1 } else
if(TestNum(f.AdiTaux2.value    , 14)< 0) { err=202; errF = f.AdiTaux2 } else
if(TestNum(f.FraisDossier.value, 50)< 0) { err=301; errF = f.FraisDossier } else
if(TestNum(f.FraisGarant.value , 50)< 0) { err=302; errF = f.FraisGarant }

console.log('err = %s', err);

if(!err)
    {
      var astm=parseInt(f.PretAstm.options[f.PretAstm.selectedIndex].value);
      var nb1=GetNum(f.PretNbMois.value, 30);
      var nb2=GetNum(f.PretDifft.value, 30);
      var nb3=GetNum(f.PretDiffa.value, 30);
      var nb4=(astm==1) ? 12 : (astm==2) ? 6 : (astm==3) ? 3 : 1;

      if(nb1<=0 || nb2<0 || nb3<0) err=501; else
      if(nb1<nb2+nb3+nb4)	   err=502; else
      if((nb1-(nb2+nb3))%nb4)	   err=503; else
      if(nb3%nb4)		   err=504;
    }

if(!err && !gIsChange1)
    { err=(gIsChange2) ? 1001 : 1000;
    }

if(err && IsAlert==1)
    {
      var s=(err==1000) ? "Répondez au questionnaire !"
	   :(err==1001) ? "Le prêt est dêjà calculé !"
			: "Saisie insuffisante ou incorrecte !";
      displayError(s, errF);
    }

return((err) ? false : true);
}

function doTalbeauAmortissemet(f) {
  var v=checkInputAmortissment(f,1);
  if(v==true) {
    CalculTAmort(f);
  }
  return false;
}


function CalculTAmort(f)
{
_PretMontant    =(f["PretMontant"   ].value) ? GetNum(f["PretMontant"].value, 82) : 0;
_PretTaux       =(f["PretTaux"      ].value) ? GetNum(f["PretTaux"].value, 84) : 0;
_PretNbMois     =(f["PretNbMois"    ].value) ? GetNum(f["PretNbMois"].value, 30) : 0;
_PretDiffa      =(f["PretDiffa"     ].value) ? GetNum(f["PretDiffa"].value, 30) : 0;
_PretDifft      =(f["PretDifft"     ].value) ? GetNum(f["PretDifft"].value, 30) : 0;
_PretAstm       =(f["PretAstm"      ].value) ? parseInt(f["PretAstm"].value) : 0;
_AdiTaux1       =(f["AdiTaux1"      ].value) ? GetNum(f["AdiTaux1"].value, 84) : 0;
_AdiTaux2       =(f["AdiTaux2"      ].value) ? GetNum(f["AdiTaux2"].value, 84) : 0;
_AdiMode1       =(f["AdiMode1"      ].value) ? parseInt(f["AdiMode1"].value) : 0;
_AdiMode2       =(f["AdiMode2"      ].value) ? parseInt(f["AdiMode2"].value) : 0;
_FraisDossier   =(f["FraisDossier"  ].value) ? GetNum(f["FraisDossier"].value, 82) : 0;
_FraisGarant    =(f["FraisGarant"   ].value) ? GetNum(f["FraisGarant"].value, 82) : 0;


if(TesteData()==0)
    { FillTblAmort();
      PretCalculTotaux();
      PretCoutCredit();
      PretCalculTeg();
    }

if(gNbLigne>0)
    {
      var sHTML = "";

      sHTML+=
'<div class="sfi-calc--result__scrollable">'
+'<table width="100%" cellpadding="2" class="sfi-calc--zonePTZ__table">'
+'  <thead>'
+'    <tr>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap>Coût total du crédit<br>'
+'	    </td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap><b>TEG</b><br>'
+'      (taux effectif global)</td>'
+'    </tr>'
+'  </thead>'
+'  <tbody>'
+'    <tr>'
+'      <td nowrap align="center">&nbsp;<br>'
+_StrCoutCredit+'	 <br>'
+'      &nbsp;</td>'
+'      <td nowrap align="center">&nbsp;<br>'
+_StrTeg+'	  <br>'
+'      &nbsp;</td>'
+'    </tr>'
+'  </tbody>'
+'</table>'
+'</div>'

+'<div class="sfi-calc--result__scrollable">'
+'<table width="100%" cellpadding="2" class="sfi-calc--zonePTZ__table"'
+'  <thead>'
+'    <tr>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%"><p align="center">Numéro <br>'
+'      d&#146;échéance</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Dette<br>'
+'      restante</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Amortis-<br>'
+'      sement</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Intérêts</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Assurance<br>'
+'      obligatoire</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Assurance<br>'
+'      facultative</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Echéance<br>'
+'      Hors assur.</td>'
+'      <th class="sfi-calc--zonePTZ__table__entete" nowrap width="12%" align="center">Echéance<br>'
+'      Avec assur.</td>'
+'    </tr>'
+'  </thead>'
+'  <tr>'
+'    <td nowrap align="center">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=FormateVal(i+1, 0);
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=FormateVal(gTblCrd[i], 2);
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=FormateVal(gTblAmort[i], 2);
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=FormateVal(gTblInteret[i], 2);
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=(gTblAdi1[i]) ? FormateVal(gTblAdi1[i], 2) : "-";
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=(gTblAdi2[i]) ? FormateVal(gTblAdi2[i], 2) : "-";
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=FormateVal(gTblEcheance[i], 2);
		    if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'    <td nowrap align="right">';

      var i;
	  var s="";
	  for(i=0; i<gNbLigne; i++)
	      { s+=FormateVal(gTblEcheance[i]+gTblAdi1[i]+gTblAdi2[i], 2);
		if(i+1<gNbLigne) s+="<br>";
	      }
	  sHTML+=s;
      sHTML+='</td>'
+'  </tr>'
+'  <tr>'
+'    <td nowrap align="center">Totaux</td>'
+'    <td nowrap align="center">-</td>'
+'    <td nowrap align="right">'

+((gNbLigne>0) ? FormateVal(gTblAmort[gNbLigne],2) : "&nbsp;")
+'</td>'
+'    <td nowrap align="right">'+((gNbLigne>0) ? FormateVal(gTblInteret[gNbLigne],2) : "&nbsp;")
+'    </td>'
+'    <td nowrap align="right">'+((gNbLigne>0) ? FormateVal(gTblAdi1[gNbLigne],2) : "&nbsp;")
+'    </td>'
+'    <td nowrap align="right">'+((gNbLigne>0) ? FormateVal(gTblAdi2[gNbLigne],2) : "&nbsp;")
+'    </td>'
+'    <td nowrap align="right">'+((gNbLigne>0) ? FormateVal(gTblEcheance[gNbLigne],2) : "&nbsp;")
+'    </td>'
+'    <td nowrap align="right">'+((gNbLigne>0) ? FormateVal(gTblEcheance[gNbLigne]
					       +gTblAdi1[gNbLigne]
					       +gTblAdi2[gNbLigne],2) : "&nbsp;")
+'    </td>'
+'  </tr>'
+'</table>'
+'</div>';

      // document.getElementById("IdTAmort").innerHTML = sHTML;
      // affichage du résultat
      $('.sfi-calc--result__content').html(sHTML);
      $('.sfi-calc--result').removeClass('no-result error');

      console.log('Tableau amortissement ok');
      $(".sfi-calc--resultat").css('display', 'block');
      jQuery( document.body ).trigger( 'post-load' );


      gtag('event', 'submit', {
        'send_to' : 'UA-122662450-4',
        'event_category' : 'Tableau d\'amortissement'
      });

    }
}


function BodyOnLoad()
{
var f=document.ffff;

f["PretMontant"].value="100000";
f["PretTaux"].value="4,5";
f["PretNbMois"].value="180";
///f["PretDiffa"].value="60";
///f["PretDifft"].value="60";
f["AdiTaux1"].value="0,35";
///f["AdiTaux2"].value="1";
///f["FraisDossier"].value="300";
///f["FraisGarant"].value="100";

gIsChange1=1;
gIsChange2=1;
}
